import { ValueOf } from 'types';

export const ValuationMode = { WEIGHT: 'WEIGHT', DOLLAR: 'DOLLAR' } as const;
export type ValuationMode = ValueOf<typeof ValuationMode>;
